import * as React from "react";
import PropTypes from "prop-types";

import Stack from "@mui/material/Stack";
import Typography from "ui/Typography";

const SectionDescription = (props) => {
  const {
    LeadIcon,
    title,
    description,
    TrailComponent,
    titleProps,
    descriptionProps,
  } = props;

  return (
    <Stack direction="row" paddingY="12px" gap="16px">
      {LeadIcon && <LeadIcon width="20px" height="20px" />}
      <Stack flex="1">
        <Typography
          variant="subtitle1"
          color="surface.onSurfaceVariant"
          {...titleProps}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          color="surface.onSurfaceVariant"
          {...descriptionProps}
        >
          {description}
        </Typography>
      </Stack>
      {TrailComponent && <TrailComponent />}
    </Stack>
  );
};

SectionDescription.propTypes = {
  LeadIcon: PropTypes.any,
  title: PropTypes.string,
  description: PropTypes.string,
  TrailComponent: PropTypes.func,
  titleProps: PropTypes.object,
  descriptionProps: PropTypes.object,
};

export default SectionDescription;
